import { render, staticRenderFns } from "./edit-flag-expiry.vue?vue&type=template&id=58013a42&"
import script from "./edit-flag-expiry.vue?vue&type=script&lang=js&"
export * from "./edit-flag-expiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports